import { supabase } from "@/utils/supabase";

const FUNCTIONS_URL = `${process.env.VUE_APP_SUPABASE_URL}/functions/v1`;

// 펫 케어 행위(다마고치형: 밥주기 등) — Edge Function(pet) 경유. JWT 인증.
async function callFn(path, body) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error("E_NOT_LOGGED_IN");

  const res = await fetch(`${FUNCTIONS_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: process.env.VUE_APP_SUPABASE_KEY,
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw Object.assign(new Error(json.message || "E_REQUEST_FAILED"), { detail: json });
  }
  return json;
}

export default {
  // 밥주기. 반환: { hunger, energy, qtyLeft, favorite, bonus }
  async feed(itemId, qty = 1) {
    return await callFn("/pet/feed", { itemId, qty });
  },
  // 놀아주기(장난감). 반환: { mood, usesLeft, broke, favorite, bonus }
  async play(itemId) {
    return await callFn("/pet/play", { itemId });
  },
};
